/**
 * Format a date string into a human-readable time label.
 * Recent: "now", "5m", "3h". Past 24h: short date "Jan 16".
 */
export function formatTimeAgo(dateStr: string | null): string {
  if (!dateStr) return ""
  const date = new Date(dateStr)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  if (diffMins < 1) return "now"
  if (diffMins < 60) return `${diffMins}m`
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h`
  // Beyond 24h: show exact date
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric" })
}
